import { FunctionComponent } from "react";

import { FontSizes, PrimaryButton, Stack, Text } from "@bps/fluent-ui";
import { useFormContext } from "@bps/form-api";

import { VerifyPinFormValues } from "./VerifyPinForm.interface";
import { VerifyPinFormInputs } from "./VerifyPinFormInputs";

interface VerifyPinFormFieldsProps {
  isError: boolean;
}

export const VerifyPinFormFields: FunctionComponent<
  VerifyPinFormFieldsProps
> = ({ isError }) => {
  const { actions } = useFormContext<VerifyPinFormValues>();

  return (
    <Stack tokens={{ childrenGap: 24 }}>
      <Stack tokens={{ childrenGap: 12 }}>
        <VerifyPinFormInputs isError={isError} />
        <Text
          styles={{
            root: {
              fontSize: FontSizes.size12,
              padding: 8,
              borderRadius: 4,
              backgroundColor: "rgba(36, 110, 201, 0.1)"
            }
          }}
        >
          <strong>Eg:</strong> 10/12/1993 becomes 10/12/93
        </Text>
      </Stack>
      <PrimaryButton
        styles={{ root: { height: 56, padding: "6px 20px" } }}
        onClick={() => actions.submit()}
      >
        Continue
      </PrimaryButton>
    </Stack>
  );
};
